import { Skeleton, Stack } from "@mui/material";
import { type FC } from "react";

import { DESKTOP_VISIBLE_CARDS } from "~/components/UI/CardsCarousel";
import { SKELETON_CARD_HEIGHT } from "~/feature/news/constants";

import * as Styled from "./NewsFeedSkeleton.styles";

export const NewsFeedSkeleton: FC = () => {
  return (
    <Stack sx={{
      gap: 1.5
    }}>
      <Skeleton variant="text" width={180} height={28} />

      <Styled.Viewport>
        <Styled.Row>
          {Array.from({ length: DESKTOP_VISIBLE_CARDS }).map((_, index) => (
            <Styled.Cell key={index}>
              <Skeleton variant="rounded" height={SKELETON_CARD_HEIGHT} />
            </Styled.Cell>
          ))}
        </Styled.Row>
      </Styled.Viewport>
    </Stack>
  );
};
